import { Button } from '@fluentui/react-components';
import { ArrowUndoRegular } from '@fluentui/react-icons';
import { PropsWithChildren, ReactNode } from 'react';
import DetectionCountdown from './DetectionCountdown';

type Props = {
  rightDisabled?: boolean;
  onRestart: () => void;
  left?: ReactNode; // e.g. <RefModeTabs ... />
  targetDate: string;
};

const PreviewHeader = ({ left, rightDisabled, onRestart, targetDate }: PropsWithChildren<Props>) => {
  return (
    <div className="flex flex-col gap-3 py-3 sm:flex-row sm:items-end sm:justify-between">
      {left}
      <div className="ml-auto flex flex-col items-end gap-3">
        <DetectionCountdown targetDate={targetDate} className="md:absolute md:top-4 md:right-8" />
        <Button
          disabled={rightDisabled}
          appearance="secondary"
          size="medium"
          icon={<ArrowUndoRegular />}
          onClick={onRestart}
          className="w-fit"
        >
          Restart detection
        </Button>
      </div>
    </div>
  );
};

export default PreviewHeader;
